import React from 'react';
import PropTypes from 'prop-types';

function ContactForm({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" d="M2.65 6.35h7.7M2.65 10.35h4.7M2.65 14.35h1.7" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M19.15 9.9L10.33 18.7 6 20l1.323-4.351 8.82-8.802M19.149 9.9l-3.006-3.053M19.149 9.9l2.148-2.146a1 1 0 00.006-1.41L19.7 4.718a1 1 0 00-1.42-.005l-2.137 2.135M8.133 15.733l2.134 2.134"
      />
    </svg>
  );
}

ContactForm.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default ContactForm;
